import React from 'react';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const MAX_WIDTH_MESSAGE = '45%';

export const MessageRow = styled(({ isOutbound: _isOutbound, ...other }) => <div {...other} />)(
  ({ isOutbound, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: isOutbound ? 'flex-end' : 'flex-start',
    marginBottom: theme.spacing(1)
  })
);

export const MessageContainer = styled(({ isOutbound: _isOutbound, ...other }) => (
  <div {...other} />
))(({ isOutbound }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  justifyContent: isOutbound ? 'flex-end' : 'flex-start'
}));

export const MessageBubble = styled(({ isOutbound: _isOutbound, ...other }) => <div {...other} />)(
  ({ isOutbound, theme }) => ({
    backgroundColor: isOutbound ? theme.palette.primary.main : theme.palette.grey[300],
    borderRadius: theme.spacing(2, 2, isOutbound ? 0 : 2, isOutbound ? 2 : 0),
    margin: theme.spacing(0, 1),
    maxWidth: MAX_WIDTH_MESSAGE,
    padding: theme.spacing(2),
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    hyphens: 'auto',
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '60%'
    }
  })
);

export const MessageText = styled(
  ({ isOutbound: _isOutbound, isHourText: _isHourText, ...other }) => <Typography {...other} />
)(({ isOutbound, isHourText, theme }) => ({
  color: isOutbound ? theme.palette.common.white : 'inherit',
  fontSize: isHourText ? 13 : 16,
  textAlign: isHourText && isOutbound ? 'right' : 'left',
  whiteSpace: 'pre-wrap',
  '& em': {
    fontStyle: 'normal',
    color: isOutbound ? theme.palette.common.white : theme.palette.grey[800],
    fontWeight: 700
  }
}));
